module.exports = __webpack_public_path__ + "static/media/gery-white-blue-20.dfb047b4.png";